import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      marginTop: '26px',
      marginBottom: '15px',
      marginLeft: '23px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '16px',
      lineHeight: '21px',
      color: '#2C2D3E',
      width: '850px',
    },
    flexContent: {
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'hidden',
    },
    actionIcon: {
      position: 'relative',
      top: '1px',
      color: '#3C419A',
    },
    container: {
      width: '100%',
      height: '100%',
      margin: '20px',
    },
    modalBody: {
      width: 'calc(100% - 50px)',
      height: '525px',
      margin: '25px 25px',
    },
    leftMenu: {
      background: 'rgba(202, 202, 252, 0.15)',
      height: '525px',
      overflowY: 'auto',
      overflowX: 'hidden',
      borderRight: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    sessionTree: {
      position: 'absolute',
      maxHeight: '500px',
      width: '300px',
      overflowY: 'auto',
      overflowX: 'hidden',
      listStyle: 'none',
      margin: '0px',
      padding: '5px 0px 10px 0px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '12px',
      fontWeight: 500,
    },
    detailsHeader: {
      display: 'flex',
      fontWeight: 500,
      borderBottom: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    breadcrumbs: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      height: '25px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '11px',
      padding: '6px',
      marginLeft: '15px',
      marginRight: 'auto',
      fontWeight: 500,
      color: '#2C2D3E',
    },
    breadcrumbsIcon: {
      position: 'relative',
      display: 'flex',
      alighItems: 'center',
      left: '9px',
      top: '10px',
      width: '35px',
      height: '16px',
      color: 'rgba(60, 65, 154, 0.6)',
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
      borderRadius: '5px',
      cursor: 'pointer',
    },
    detailsHeaderActive: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '11px',
      fontWeight: 700,
      color: '#3C419A',
    },
    editButton: {
      position: 'absolute',
      top: '146px',
      left: '830px',
      width: '84px',
      height: '30px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontSize: '12px',
      color: '#2C2D3E',
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
    },
    editButtonIcon: {
      width: '14px',
      justifyContent: 'start',
      color: '#81818D',
      transform: 'translateX(0px)',
    },
    deleteButtonIcon: {
      width: '17px',
      justifyContent: 'start',
      color: '#81818D',
      transform: 'translate(0px, 0px)',
    },
    addSessionItemButton: {
      position: 'absolute',
      top: '550px',
      right: '50px',
      height: '35px',
    },
    addSessionItemButtonIcon: {
      width: '22px',
      height: '22px',
      left: '750px',
      top: '550px',
      color: '#3C419A',
      cursor: 'pointer',
      transform: 'translateX(-10px)',
    },
    maxTextItem: {
      maxWidth: '800px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    lockIcon: {
      '&.MuiSvgIcon-root': {
        width: '15px',
        height: '15px',
        position: 'relative',
        top: '3px',
        marginLeft: '15px',
      },
    },
    gridBorder: {
      border: 'solid 1px rgba(44, 45, 62, 0.3)',
      borderRadius: '8px',
    },
  }),
);

export const styles = () =>
  createStyles({
    root: {
      width: '960px',
      height: '640px',
      margin: 0,
      padding: 0,
    },
  });
